/**
 * 会社ごとの機能フラグ（画面側の判定）。
 *
 * 全社が同じビルドを共有しているため、新機能は会社ごとのフラグで出し分ける。
 * 値はログイン応答（data.features）と GET /auth/features から受け取り localStorage に保持する。
 * オフラインでも直前の値で判定できるようにキャッシュしている。
 */
const KEY = "catms_features";

export function saveFeatures(features: unknown): void {
  if (!features || typeof features !== "object") return;
  try { localStorage.setItem(KEY, JSON.stringify(features)); } catch { /* noop */ }
}

export function getFeatures(): Record<string, boolean> {
  try { return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Record<string, boolean>; }
  catch { return {}; }
}

/** その会社でこの機能が有効か（未設定＝無効） */
export function hasFeature(key: string): boolean {
  return getFeatures()[key] === true;
}

export function clearFeatures(): void {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}
